import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const PrimarySmall = S.PrimarySmallBase;

PrimarySmall.displayName = "PrimarySmall";

PrimarySmall.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.LIGHT, fontWeightOptions.SEMI_BOLD])
};

PrimarySmall.defaultProps = {
  weight: fontWeightOptions.LIGHT
};

export default PrimarySmall;
